<template>
  <div>
    <el-tree
      :data="data"
      :node-key="nodeKey"
      :default-expanded-keys="firstData"
      accordion
      highlight-current
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.label}}</span>
        <div class="tree-button">
          <el-button
            v-if="data.parentId!='0'"
            type="text"
            size="mini"
            @click="showModal('move',node,data)"
          >
            <i class="el-icon-sort"></i>
          </el-button>
          <el-button
            v-if="data.parentId!='0'"
            type="text"
            size="mini"
            @click="showModal('edit',node,data)"
          >
            <i class="el-icon-edit"></i>
          </el-button>
          <el-button type="text" size="mini" @click="showModal('add',node,data)">
            <i class="el-icon-plus"></i>
          </el-button>
          <el-button v-if="data.parentId!='0'" type="text" size="mini" @click="remove(node,data)">
            <i class="el-icon-close"></i>
          </el-button>
        </div>
      </span>
    </el-tree>
    <OAModalForm
      :title="title"
      :visible.sync="dialogVisible"
      :form-data="formData"
      @on-submit="submit"
      @on-cancel="cancel"
    ></OAModalForm>
  </div>
</template>
<script>
import { Json2TreeCode, getValue } from "@/common/util.js";
import OAModalForm from "@/components/OAModalForm/OAModalForm";
import formData from "./formData.js";

export default {
  name: "OATree",
  components: { OAModalForm },
  data() {
    return {
      dialogVisible: false,
      firstData: [],
      data: [],
      title: "",
      formData: {},
      type: "",
      nodeData: {},
    };
  },
  props: ["treeData", "nodeKey"],
  methods: {
    handleNodeClick(data) {
      this.$emit("node-click", data);
    },
    showModal(type, node, data) {
      this.nodeData = data;
      this.type = type;
      this.dialogVisible = true;
      switch (type) {
        case "move":
          this.title = "移动组";
          this.formData = formData.move(data);
          break;
        case "edit":
          this.title = "编辑组";
          this.formData = formData.edit(data);
          break;
        case "add":
          this.title = "新增组";
          this.formData = formData.add;
          break;
      }
    },
    submit() {
      let parentId = this.nodeData.parentId;
      let id = this.nodeData.id;
      let data = getValue(this.formData);
      this.dialogVisible = false;
      switch (this.type) {
        case "move":
          this.$emit("move-click", { parentId: data.departmentId, id: id,departName:data.departName });
          break;
        case "edit":
          this.$emit("edit-click", { ...data, parentId: parentId, id: id });
          break;
        case "add":
          this.$emit("add-click", { ...data, parentId: id });
          break;
      }
    },
    remove(node, data) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$emit("remove-click", { id: data.id });
        })
        .catch(() => {});
    },
    cancel() {
      this.dialogVisible = false;
    }
  },
  watch: {
    treeData: {
      handler: function(val, oldValue) {
        if (val && val.length) {
          this.data = Json2TreeCode(val);
          this.firstData = [this.data[0].id];
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {}
};
</script>
<style lang="scss">
.el-tree {
  .el-tree-node__content {
    line-height: 40px;
    &:hover {
      .tree-button {
        display: inline-block;
      }
    }
  }
}
.tree-button {
  position: absolute;
  right: 10px;
  display: none;
  .el-icon-sort {
    color: #67c23a;
    transform: rotate(90deg);
  }
  .el-icon-plus {
    color: #f7ae00;
  }
  .el-icon-edit {
    color: #1296db;
  }
  .el-icon-close {
    color: #ec2a33;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/OATree/OATree.vue